    import {resetPasswordTypes} from "../AuthActionsTypes/ResetPasswordActionsTypes";

export const setUserResetPasswordError = error => {
    return {
        type: resetPasswordTypes.SET_ERROR,
        name: resetPasswordTypes.USER_RESET_PASSWORD_GENERAL_ERROR,
        message: "" + error,
    };
};

export const removeUserResetPasswordErrors = error => {
    return {
        type: resetPasswordTypes.REMOVE_ERRORS,
    };
};
